export * from './debates-add/debates-add.component';
export * from './debates-edit/debates-edit.component';
export * from './debates-list/debates-list.component';
